export default __webpack_public_path__ + "static/joko-app-screenshot-home-3-en@2x-7991653ba3f7f220bcf99436eb9e02be.webp";